import { IconsTypesProps } from '../icons/types';

export const CranePumpWidget = ({ width = 50, height = 100 }: IconsTypesProps) => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 79.000000 237.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <metadata>Created by potrace 1.10, written by Peter Selinger 2001-2011</metadata>
    <g
      transform="translate(0.000000,237.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    >
      <path
        d="M305 2356 c-42 -18 -92 -70 -119 -125 -32 -63 -106 -324 -106 -374 0
-22 -6 -48 -14 -56 -34 -41 -70 -273 -63 -417 3 -54 5 -123 6 -152 0 -79 18
-55 26 35 6 64 10 74 20 60 7 -9 15 -45 19 -79 11 -114 38 -252 66 -348 16
-52 27 -96 25 -98 -2 -2 -13 -1 -24 3 -24 7 -39 49 -62 180 -9 55 -18 88 -18
73 -1 -15 8 -74 19 -130 20 -106 42 -143 79 -136 21 5 19 25 -13 133 -15 50
-36 153 -47 230 -20 137 -35 190 -54 190 -6 0 -13 -13 -16 -30 l-7 -30 -1 35
c-1 19 -4 46 -8 59 -6 22 -4 22 45 -12 46 -31 155 -67 205 -67 10 0 16 -21 20
-84 8 -116 30 -194 87 -311 47 -99 90 -155 116 -155 8 0 14 -4 14 -9 0 -5 7
-11 16 -13 9 -2 -29 -4 -85 -6 -114 -3 -208 14 -291 51 l-56 24 -13 107 c-8
58 -17 106 -21 106 -4 0 -3 21 1 47 4 27 8 62 7 78 0 27 -1 27 -11 -10 -15
-60 -11 -148 12 -259 25 -119 26 -153 5 -195 -15 -31 -16 -49 -1 -209 4 -47
33 -86 56 -77 15 6 -2 -14 -67 -77 -28 -28 -32 -38 -32 -82 0 -58 27 -103 54
-93 29 11 45 -4 52 -49 8 -53 25 -65 91 -62 26 1 86 -1 133 -4 47 -4 77 -5 67
-2 -24 7 -19 57 6 62 14 3 17 -4 17 -37 0 -41 0 -41 38 -41 48 0 59 8 64 45 3
25 8 31 38 35 43 7 60 17 60 34 0 7 8 21 19 30 10 9 21 37 25 63 5 35 14 55
38 76 l31 28 -6 93 c-5 83 -3 93 14 104 15 9 19 24 19 63 0 41 -5 54 -27 75
-14 13 -37 27 -50 30 -21 6 -23 12 -23 68 0 38 14 114 36 201 60 233 64 255
70 400 9 226 -30 421 -93 460 -31 19 -32 23 -31 80 l1 60 7 -50 c7 -44 7 -42
4 18 -5 104 -74 314 -122 370 -57 67 -78 80 -103 66 -12 -6 -35 -8 -51 -5 -17
3 -41 0 -58 -9 -38 -20 -112 -105 -105 -122 2 -8 1 -12 -4 -8 -11 6 -31 -45
-69 -180 -24 -87 -28 -113 -24 -202 3 -90 6 -103 23 -108 10 -4 19 -11 19 -17
0 -5 -8 -7 -18 -4 -15 5 -15 5 -1 -6 28 -23 41 -126 29 -239 -11 -115 -7 -130
35 -111 15 7 31 10 36 7 5 -4 9 -1 9 4 0 6 7 11 15 11 8 0 15 -5 15 -11 0 -26
20 6 21 34 1 30 2 29 8 -8 4 -22 10 -46 14 -52 6 -10 -7 -13 -55 -11 l-63 2
53 3 c28 2 52 7 52 11 0 9 -43 8 -95 -1 -52 -10 -122 11 -181 55 l-45 33 5 85
c6 96 32 233 51 269 l13 25 0 -30 c0 -16 -6 -51 -14 -78 -18 -62 -18 -77 0
-102 13 -17 16 -17 29 -4 28 30 43 120 36 220 l-5 95 -4 -100 c-4 -134 -3
-128 -18 -131 -7 -1 -8 0 -3 2 6 3 7 12 4 20 -5 13 -7 13 -14 2 -6 -9 -9 -9
-9 -1 0 7 8 17 17 22 12 7 13 10 4 11 -11 0 -12 21 -8 108 3 89 11 130 46 242
46 149 77 207 134 254 34 27 46 31 102 31 35 0 67 3 71 8 13 12 -110 7 -141
-7z m164 -23 c-12 -15 -12 -16 4 -10 10 4 16 3 13 -2 -3 -5 1 -14 9 -21 8 -7
15 -9 15 -4 0 5 7 0 16 -11 8 -11 20 -20 27 -20 12 0 51 -88 62 -140 3 -16 -7
5 -23 48 -16 43 -33 81 -37 85 -5 4 -5 -2 0 -13 4 -11 27 -81 51 -155 24 -74
43 -128 44 -119 0 9 -7 36 -15 59 -8 23 -15 48 -14 54 0 6 9 -12 18 -39 15
-42 17 -66 11 -140 -4 -50 -8 -80 -9 -68 0 12 -5 25 -11 28 -5 3 -10 31 -10
61 0 40 -15 100 -51 211 -28 85 -52 153 -54 151 -3 -2 18 -73 46 -157 38 -116
49 -164 47 -201 l-3 -49 -41 28 c-22 16 -57 31 -77 35 -35 6 -37 9 -37 44 -1
51 -20 74 -61 70 -18 -2 -34 -10 -37 -18 -4 -12 -2 -13 9 -2 19 17 50 15 65
-5 21 -28 17 -33 -28 -35 -37 -1 -39 -2 -10 -5 39 -5 43 -23 5 -23 -41 0 -56
13 -48 40 5 17 4 21 -6 15 -8 -6 -11 -4 -7 7 3 8 0 39 -8 68 -8 30 -14 80 -14
112 0 31 -3 59 -7 61 -5 3 -6 -31 -3 -75 4 -59 2 -82 -7 -85 -9 -3 -5 -11 10
-24 12 -10 18 -18 13 -19 -5 0 -3 -6 3 -14 8 -10 9 -16 1 -21 -5 -3 -10 1 -10
9 0 25 -56 21 -63 -4 -3 -11 -1 -20 4 -20 5 0 10 8 10 18 1 16 2 16 6 0 3 -11
14 -18 29 -18 23 0 25 -3 22 -36 -4 -43 -24 -60 -62 -50 -26 6 -27 10 -25 54
1 27 -1 53 -5 60 -4 7 -3 12 2 12 5 0 9 7 9 15 0 9 -5 14 -11 12 -7 -2 -10
-24 -8 -55 3 -47 2 -53 -20 -61 -23 -8 -38 1 -38 24 0 6 4 4 9 -3 6 -10 10 -7
15 13 4 15 5 30 1 33 -3 3 -5 -3 -5 -13 0 -10 -2 -16 -5 -13 -4 3 -3 18 1 33
5 20 9 24 16 13 7 -9 8 -3 4 17 -5 22 -4 26 4 15 5 -8 10 -10 10 -5 0 6 3 21
5 35 5 22 4 22 -4 5 -12 -25 -13 1 -1 30 7 18 8 17 15 -10 12 -53 14 -55 32
-48 17 7 17 8 -1 11 -14 3 -17 10 -12 34 3 17 6 41 6 54 0 13 9 33 20 44 12
12 18 24 16 29 -3 4 6 19 21 32 14 13 23 18 18 10 -5 -9 -3 -12 6 -9 8 3 13
10 12 16 -1 5 8 8 20 5 16 -3 18 -2 9 5 -9 6 3 8 36 4 30 -2 52 0 56 7 4 6 10
11 13 11 3 0 -1 -8 -8 -17z m-33 -400 l-1 -58 -42 0 c-24 0 -43 3 -43 8 0 4 0
24 0 45 0 38 0 38 35 34 25 -3 36 0 41 12 10 26 12 19 10 -41z m-242 27 c23 8
26 7 24 -7 -7 -41 95 -41 112 0 8 21 9 21 9 -4 1 -32 -17 -39 -114 -44 -46 -2
-60 0 -40 5 30 8 30 8 4 9 -25 1 -39 17 -39 44 0 8 3 8 8 -1 7 -10 15 -10 36
-2z m339 -54 c5 -14 -49 -45 -81 -47 -10 0 -6 -5 10 -11 23 -8 35 -6 63 12 19
12 35 26 35 31 0 6 14 2 30 -8 29 -17 48 -48 36 -60 -3 -4 -6 1 -6 11 0 15 -6
16 -47 9 -27 -4 -64 -6 -83 -5 -19 2 -83 4 -142 5 -58 1 -102 4 -98 7 5 3 5
12 0 20 -7 12 -10 12 -16 -3 -4 -10 -3 -22 2 -27 5 -5 59 -11 119 -12 l110 -3
-96 -14 -97 -13 -61 27 c-45 21 -61 33 -61 48 0 18 5 19 66 14 40 -3 70 -10
75 -18 6 -10 9 -8 9 9 0 15 6 22 20 22 13 0 18 -5 14 -15 -4 -9 3 -16 19 -20
43 -11 81 -2 92 23 6 15 16 21 28 18 9 -2 17 0 17 5 0 14 37 10 43 -5z m-335
-86 c22 -11 46 -20 52 -20 12 0 14 -57 1 -64 -5 -3 -30 3 -55 15 -42 18 -46
23 -46 54 0 19 1 35 3 35 2 0 22 -9 45 -20z m417 -1 c4 -11 4 -23 0 -27 -6 -6
-264 -51 -297 -52 -12 0 -18 8 -18 24 0 22 6 25 68 35 37 7 101 18 142 25 101
19 98 19 105 -5z m65 -19 c13 -8 12 -10 -5 -11 -11 -1 -4 -5 15 -9 l35 -7 -35
-2 c-40 -1 -66 12 -56 28 9 13 26 14 46 1z m-390 -38 c0 -16 -8 -36 -17 -44
-24 -21 -63 -32 -63 -19 0 6 6 11 14 11 22 0 46 29 46 56 0 13 5 24 10 24 6 0
10 -13 10 -28z m346 9 c5 -6 27 -11 50 -12 35 -2 40 -5 36 -22 -3 -13 -1 -18
5 -14 7 5 9 0 6 -13 -3 -11 -15 -22 -27 -25 -78 -17 -469 -75 -476 -70 -6 3
-10 20 -10 36 0 23 6 32 27 40 15 6 34 16 42 22 7 7 84 24 170 38 86 15 158
27 162 28 3 0 9 -3 15 -8z m-418 -53 c-20 -12 -35 -10 -52 8 -27 27 -18 33 24
17 28 -11 37 -19 28 -25z m-8 -55 c0 -10 3 -36 6 -58 5 -28 3 -37 -4 -30 -16
15 -27 105 -13 105 6 0 11 -8 11 -17z m535 7 c-3 -5 -12 -10 -20 -10 -20 0
-45 -40 -45 -71 0 -26 -1 -26 -142 -48 -173 -28 -241 -34 -232 -20 11 18 -25
59 -51 59 -14 0 -25 4 -25 9 0 4 109 26 243 49 274 45 280 46 272 32z m-635
-30 c0 -6 -7 -13 -15 -16 -12 -5 -13 -10 -4 -20 9 -11 8 -14 -5 -14 -18 0 -20
13 -6 41 11 20 30 26 30 9z m652 -30 c5 -19 10 -105 12 -190 2 -87 0 -133 -4
-105 l-7 50 -2 -45 c-6 -163 -122 -477 -201 -543 -27 -23 -29 -27 -13 -36 29
-17 9 -12 -39 9 -53 23 -65 36 -111 120 -55 100 -96 234 -103 338 l-7 89 71 6
c93 9 360 55 392 67 22 9 22 10 3 6 -18 -3 -23 0 -22 17 0 12 3 16 6 10 2 -7
12 -13 21 -12 11 0 12 2 5 6 -7 2 -13 10 -13 18 0 7 -7 18 -15 25 -11 10 -15
36 -15 112 0 88 2 99 17 96 10 -2 21 -17 25 -38z m-60 -152 c-4 -4 -87 -21
-183 -37 -187 -31 -188 -30 -189 24 0 23 -3 27 -10 15 -9 -13 -10 -13 -10 0 0
8 4 20 8 26 6 10 350 70 356 62 2 -2 8 -23 13 -48 l11 -45 -5 57 c-3 31 -2 74
3 95 8 33 9 26 12 -51 2 -49 -1 -93 -6 -98z m-442 8 l0 -104 -29 -10 c-33 -12
-41 -7 -40 22 1 19 2 18 10 -4 6 -17 8 -2 6 52 -1 42 1 74 5 72 5 -3 8 10 8
29 0 36 6 47 27 47 10 0 13 -24 13 -104z m45 -24 c8 -69 6 -76 -19 -66 -13 5
-16 21 -15 98 1 85 2 89 14 61 7 -16 17 -58 20 -93z m429 -11 c9 -13 -379 -80
-392 -67 -13 13 16 21 171 47 182 30 213 33 221 20z m-14 -40 c0 -22 2 -21
-180 -51 -69 -11 -138 -22 -153 -25 -19 -3 -30 0 -34 11 -3 8 -3 17 -1 19 3 3
52 12 109 20 57 8 136 21 174 29 39 7 73 14 78 15 4 0 7 -8 7 -18z m46 -185
c-3 -29 -17 -91 -31 -137 -14 -46 -27 -98 -29 -114 -6 -52 -26 -115 -36 -115
-14 0 -12 12 11 65 11 25 19 48 17 51 -3 2 -15 -21 -27 -52 -18 -41 -21 -58
-12 -67 20 -20 11 -38 -29 -56 -22 -10 -37 -21 -33 -25 4 -4 -1 -4 -11 0 -13
5 -17 4 -12 -4 5 -8 2 -10 -9 -6 -13 5 -11 10 9 29 55 51 166 316 182 433 3
28 9 52 12 52 2 0 2 -24 -2 -54z m-100 -510 c-12 -50 -133 -86 -287 -86 -98 0
-171 14 -234 45 -27 13 -51 22 -54 20 -8 -8 104 -55 159 -66 63 -13 265 -7
321 10 20 6 53 22 72 35 35 24 47 24 47 1 0 -14 -114 -51 -200 -64 -83 -14
-254 -14 -301 -1 -20 6 -53 21 -73 35 -20 13 -36 20 -36 14 0 -5 11 -15 25
-21 14 -6 25 -15 25 -20 0 -12 -7 -10 -38 9 -25 16 -26 16 -14 1 8 -10 22 -20
33 -23 11 -4 19 -16 20 -28 0 -21 1 -21 8 -2 5 11 6 27 3 35 -3 8 -2 12 3 8 4
-4 8 -20 9 -35 1 -37 36 -42 86 -14 35 19 50 19 50 -1 0 -12 -69 -38 -104 -38
-18 0 -37 5 -44 12 -9 9 -12 9 -12 0 0 -20 -25 -14 -49 12 -18 19 -22 33 -19
68 1 23 7 46 12 50 5 3 11 32 14 63 4 47 7 55 21 49 9 -4 24 -7 33 -8 9 0 14
-5 11 -10 -4 -5 1 -7 11 -3 11 5 15 3 10 -5 -5 -7 0 -9 14 -6 12 4 20 2 17 -2
-10 -16 69 -28 180 -27 65 0 98 3 80 7 -22 5 -16 7 25 6 43 -1 68 6 115 30
l60 31 3 -30 c2 -16 1 -39 -2 -51z m102 -81 c3 -3 3 -8 -1 -11 -10 -10 -97 6
-97 18 0 10 87 4 98 -7z m-113 -4 c-18 -30 -333 -72 -360 -49 -5 4 25 8 65 8
78 1 206 20 250 38 32 14 53 15 45 3z m5 -51 c0 -38 -2 -40 -29 -40 -35 0 -83
-17 -92 -32 -4 -6 -57 -13 -123 -16 l-116 -5 0 36 c0 44 2 44 145 50 83 4 168
22 213 46 1 0 2 -17 2 -39z m76 30 c27 0 34 -4 34 -19 0 -24 -4 -27 -57 -36
l-43 -7 0 37 c0 30 3 36 16 31 9 -3 31 -6 50 -6z m-517 -16 c29 -6 30 -8 14
-20 -24 -18 -73 -18 -73 -1 0 27 10 30 59 21z m549 -49 c-9 -9 -84 -19 -76
-10 8 8 71 23 77 18 2 -1 2 -5 -1 -8z m-638 -27 c0 5 19 7 43 5 26 -3 57 1 80
11 l38 15 -3 -32 c-3 -32 -4 -32 -62 -35 -63 -3 -129 20 -157 54 -11 14 -6 13
24 -5 20 -12 37 -18 37 -13z m580 -13 c0 -6 -30 -10 -70 -10 -79 0 -99 17 -30
25 53 6 101 -1 100 -15z m-420 -27 c80 1 169 5 199 8 37 4 51 2 47 -5 -4 -6
-33 -12 -64 -13 -44 -1 -48 -2 -17 -5 22 -2 51 -6 65 -9 24 -5 24 -6 6 -20
-22 -15 -135 -18 -241 -4 l-60 7 50 2 c28 1 68 4 90 6 32 4 36 3 20 -5 -18 -9
-17 -10 5 -5 14 2 50 5 80 6 54 2 54 2 -20 10 -41 5 -118 6 -171 3 -62 -3
-107 0 -125 7 -66 27 -75 17 -11 -11 47 -21 182 -40 287 -40 l65 0 -33 -22
c-30 -19 -43 -20 -132 -15 -55 3 -123 15 -156 26 -32 11 -63 17 -69 14 -5 -4
-7 -3 -3 1 3 4 -2 16 -13 27 -32 32 -25 49 19 42 20 -4 102 -6 182 -5z m395
-1 l44 10 6 -41 c9 -65 4 -84 -19 -78 -10 3 -17 1 -13 -4 6 -10 -132 -2 -150
9 -13 8 -23 57 -12 57 5 0 9 13 9 29 l0 28 45 -10 c31 -7 59 -7 90 0z m-155
-76 c0 -11 -13 -29 -30 -41 -16 -12 -30 -30 -30 -41 0 -10 -7 -19 -15 -19 -10
0 -15 10 -15 29 0 21 10 37 38 60 44 36 52 38 52 12z m-384 -10 c-13 -21 110
-50 212 -51 71 0 72 0 72 -26 l0 -27 -97 5 c-109 6 -163 23 -188 62 -15 22
-14 46 1 46 3 0 3 -4 0 -9z m112 -21 c37 -5 92 -11 122 -13 46 -3 43 -4 -20
-5 -72 -2 -183 17 -198 33 -4 5 1 5 11 2 11 -4 49 -12 85 -17z m-108 -41 c0
-3 17 -14 38 -24 29 -15 63 -20 165 -22 l127 -2 0 29 c0 19 7 33 20 40 18 10
20 8 20 -24 0 -23 6 -39 18 -45 9 -6 15 -11 12 -11 -35 -7 -59 -7 -55 1 4 5 2
9 -4 9 -5 0 -13 -4 -16 -10 -9 -15 -202 -12 -260 4 -107 29 -146 61 -113 94
10 10 16 8 30 -10 10 -13 18 -26 18 -29z m413 27 c9 1 15 -1 12 -6 -6 -10 32
-20 75 -18 33 1 32 1 -10 8 -42 7 -43 7 -10 8 53 2 80 -7 73 -26 -5 -11 -3
-13 8 -7 12 7 12 6 1 -6 -7 -8 -16 -14 -20 -14 -4 0 -19 -9 -34 -19 -18 -12
-40 -17 -63 -14 -24 3 -35 0 -35 -9 0 -7 -5 -13 -10 -13 -7 0 -7 6 -2 18 10
18 5 45 -6 38 -4 -2 -7 13 -7 35 -1 21 2 35 5 30 3 -4 13 -7 23 -5z m-506 -82
c-6 -34 -5 -35 8 -18 13 17 14 16 4 -13 -15 -44 -39 -43 -39 1 0 41 8 66 22
66 7 0 8 -14 5 -36z m80 16 c62 -30 118 -39 231 -40 100 0 102 0 90 -20 -33
-53 -368 3 -368 61 0 23 -3 23 47 -1z m538 -53 c-12 -44 -95 -101 -95 -63 0 8
-3 21 -6 30 -4 11 5 18 35 26 26 7 39 15 35 22 -4 6 -3 8 4 4 6 -3 14 -1 17 5
11 17 16 3 10 -24z m-505 -9 c40 -15 91 -22 183 -25 l128 -6 -2 -43 c-2 -24
-6 -44 -11 -44 -4 0 -6 19 -4 42 3 27 1 37 -5 27 -5 -8 -9 -26 -9 -41 0 -31 1
-31 -120 -28 -95 2 -240 43 -240 69 0 5 17 1 38 -8 20 -10 57 -23 82 -29 64
-15 217 -26 223 -16 2 5 -34 10 -82 11 -127 3 -249 38 -264 75 -3 7 -6 2 -6
-11 -1 -13 -4 -22 -7 -19 -3 3 -2 22 2 43 5 28 10 35 23 30 9 -4 41 -16 71
-27z m394 -20 c15 -59 3 -78 -50 -78 -20 0 -24 5 -24 30 0 28 3 30 38 32 l37
1 -37 4 c-53 6 -51 33 3 33 19 0 28 -6 33 -22z m95 -35 c-8 -9 -32 -24 -54
-34 -22 -10 -34 -19 -27 -19 7 0 23 5 35 12 20 10 21 10 8 -6 -9 -11 -24 -16
-38 -13 -13 2 -26 0 -29 -4 -7 -12 -64 -11 -64 1 0 6 11 10 25 10 13 0 53 16
87 35 73 40 75 40 57 18z m-478 -87 c4 -23 2 -36 -5 -36 -22 0 -33 16 -39 52
-5 35 -4 36 16 29 15 -6 24 -20 28 -45z m55 24 c8 0 14 -10 14 -24 0 -17 -7
-25 -24 -28 -26 -5 -36 7 -36 44 0 14 5 18 16 14 9 -3 22 -6 30 -6z m132 -16
c15 -5 22 -14 22 -31 0 -24 -2 -25 -37 -19 -21 3 -50 6 -65 6 -23 0 -28 4 -28
25 0 23 4 25 43 25 23 0 52 -3 65 -6z m140 -4 c7 0 12 -13 12 -30 0 -28 -3
-30 -35 -30 -34 0 -35 2 -35 36 0 33 2 36 23 30 12 -3 28 -6 35 -6z"
      />
      <path d="M367 2027 c-3 -9 6 -13 29 -14 29 -1 33 1 23 13 -14 18 -45 18 -52 1z" />
      <path
        d="M107 1293 c-12 -11 -8 -57 12 -154 24 -112 48 -186 96 -286 41 -83
67 -102 113 -81 42 20 40 55 -9 128 -56 85 -95 173 -124 283 -23 86 -42 117
-70 117 -7 0 -15 -3 -18 -7z m45 -20 c8 -10 25 -56 37 -103 25 -99 65 -189
122 -277 44 -67 46 -91 11 -109 -42 -21 -58 -7 -107 97 -70 150 -129 409 -93
409 8 0 22 -8 30 -17z"
      />
      <path
        d="M36 1213 c-18 -113 -19 -126 -8 -120 5 4 13 39 17 78 8 75 1 105 -9
42z"
      />
    </g>
  </svg>
);
